<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g fill="none" fill-rule="evenodd">
      <path
        fill="#13A2E8"
        d="M7.5 4.977c-.674 0-1.307.263-1.784.74-.476.476-.739 1.109-.739 1.784 0 .672.263 1.307.74 1.783.983.983 2.583.983 3.567 0 .476-.476.738-1.11.738-1.783 0-.675-.262-1.308-.738-1.784-.477-.477-1.11-.74-1.784-.74zm0 6.655c-1.059 0-2.118-.402-2.923-1.209-.781-.78-1.211-1.818-1.211-2.922 0-1.105.43-2.143 1.21-2.923.781-.783 1.82-1.213 2.924-1.213 1.104 0 2.142.43 2.923 1.213.78.78 1.21 1.818 1.21 2.923 0 1.104-.43 2.142-1.21 2.922-.806.807-1.865 1.209-2.923 1.209z"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#13A2E8"
        d="M7.5 1.612c-1.509 0-3.018.574-4.166 1.723-2.297 2.297-2.297 6.034 0 8.331 2.297 2.297 6.034 2.297 8.332 0 2.297-2.297 2.297-6.034 0-8.331-1.149-1.15-2.658-1.723-4.166-1.723zm0 13.389c-1.922 0-3.843-.732-5.306-2.196C-.73 9.88-.73 5.121 2.194 2.194c2.925-2.925 7.686-2.925 10.611 0 2.926 2.927 2.926 7.686 0 10.611-1.462 1.464-3.384 2.196-5.305 2.196z"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#FFF"
        d="M6.297 4.417L4.416 6.296 1.02 3.357 3.357 1.02 6.297 4.417"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#13A2E8"
        d="M2.202 3.315l2.175 1.883.82-.821-1.883-2.175-1.112 1.113zm2.214 3.788c-.187 0-.375-.065-.527-.196L.493 3.965c-.17-.146-.27-.356-.278-.58-.008-.222.077-.44.235-.597L2.787.45c.158-.159.373-.244.598-.236.224.008.434.11.58.278l2.941 3.395c.277.32.26.799-.04 1.099l-1.88 1.879c-.157.158-.363.237-.57.237z"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#FFF"
        d="M8.703 10.584L10.583 8.703 13.979 11.644 11.643 13.979 8.703 10.584"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#13A2E8"
        d="M9.803 10.622l1.883 2.175 1.111-1.11-2.174-1.884-.82.82zm1.84 4.164h-.029c-.224-.008-.434-.11-.58-.278l-2.94-3.397c-.277-.32-.26-.799.039-1.097l1.88-1.881c.3-.298.778-.316 1.098-.039l3.396 2.94c.169.146.27.356.277.58.009.224-.077.441-.235.6l-2.336 2.334c-.151.153-.357.238-.57.238z"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#FFF"
        d="M4.416 8.703L6.297 10.584 3.357 13.979 1.02 11.644 4.416 8.703"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#13A2E8"
        d="M2.202 11.686l1.112 1.111 1.882-2.175-.82-.819-2.174 1.883zm1.155 3.1c-.214 0-.42-.085-.57-.238L.45 12.213c-.158-.158-.243-.375-.235-.6.008-.223.109-.433.278-.58l3.396-2.939c.32-.277.798-.259 1.097.039l1.88 1.881c.3.298.317.776.04 1.097l-2.94 3.397c-.147.168-.357.27-.58.278h-.03z"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#FFF"
        d="M10.583 6.296L8.703 4.417 11.643 1.02 13.979 3.357 10.583 6.296"
        transform="translate(1.5 1.5)"
      />
      <path
        fill="#13A2E8"
        d="M9.803 4.377l.82.82 2.174-1.882-1.111-1.113-1.883 2.175zm.78 2.726c-.206 0-.413-.079-.57-.237l-1.88-1.879c-.299-.3-.316-.778-.04-1.099l2.94-3.395c.147-.168.357-.27.581-.278.226-.01.44.077.599.236l2.336 2.337c.158.158.244.375.235.598-.007.223-.108.433-.277.58l-3.396 2.94c-.152.132-.34.197-.528.197z"
        transform="translate(1.5 1.5)"
      />
    </g>
  </svg>
</template>